import React, { useEffect, useState } from "react";
import Stomp from "stompjs";
import axios from "axios";
import { NotificationManager } from "react-notifications";
import { forEach } from "jszip";

//import ActiveMq from "./ActiveMq";
let clientRef = null;
let instance = axios.create();
const username = "WN8z55WbAzF?bgy!BW5S9VB9$N#$fmUPx!fDf3=ZJft3mY3c@b";
const password = "DzuJVh%k&Msvr@=k2a?zZz#4CuZ55awXSYkVm?_a#+a@xQ!pDn";
let lastheartbeatTelefono = null;
let lastheartbeatOne = null;
let socketOpened = false;

let url    =  "wss://b-120f4817-28b4-42b1-8484-d17d4baa1caa-2.mq.mx-central-1.amazonaws.com:61619";
const url1 =  "wss://b-120f4817-28b4-42b1-8484-d17d4baa1caa-1.mq.mx-central-1.amazonaws.com:61619";
const url2 =  "wss://b-120f4817-28b4-42b1-8484-d17d4baa1caa-2.mq.mx-central-1.amazonaws.com:61619";
const user = "WEBSOCKET";
const pass = "w3bs0k3t2024";
const usuario = JSON.parse(sessionStorage.getItem("usuario"));
let client = null;
const NotificacionesPatios = ({
  transportista,
  localidad,
  elementos,
  topic,
  insertarNotificaciones,
  actualizaListaElementos,
  controlador,
  plataforma,
}) => {
  useEffect(() => {
    conectar();
   
  }, []);



  const conectar = () => {
    console.log("conectar al websocket Transportistapatios: ");
    try {
      if (client && client.connected) {
        client.disconnect(() => {});
      }
    } catch (e) {}
    client = Stomp.client(url);
    client.heartbeat = {
      incoming: 20000,
      outgoing: 20000,
    };
    client.debug = () => {};
    client.reconnect_delay = 5000;
    client.connect(
      user,
      pass,
      (frame) => {

        if (topic && client.connected) {
          

          // console.log(plataforma)
            client.subscribe(topic, (message) => {

              let body =  JSON.parse(message.body)
              let data = body.data;
              let index;
              let localidades = [];


              let vista = body.vista;

              // console.log("movimiento",data)
              // console.log("vista",vista)


              if(localidad.length > 0 && controlador){
             
                localidad.forEach(element => {
                  localidades.push(element.value)
                });
                vista =  body.vista.split("-");

              }


              if(body.vista == 'navierasAlertasPatios'){

                 insertarNotificaciones(data,body)
                
              }else if(body.vista.split("-")[0] == transportista && !controlador) {
               
                actualizaListaElementos(body)
              }else if(controlador && localidades.includes(vista[1] * 1) && plataforma.filter(p=> p.value == (data.idPlataforma.id)).length){
         
                actualizaListaElementos(body)
              }

            });
        
          
        }
        
      
      },
      (err) => {
        console.log(err)
        url = (url === url1) ? url2 : url1;
        //error useCallback
        if (err.toUpperCase().includes("LOST CONNECTION")) {
          setTimeout(() => {
            conectar();
          }, 5000);
          //alert(err);
        }
        console.log(err);
      }
    );
  }

};
export default NotificacionesPatios;
